// extracted by mini-css-extract-plugin
module.exports = {"participant":"ParticipantIcon_participant__1zktx"};